"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOrderedNumberArray = void 0;
var buildOrderedNumberArray = function (_a) {
    var _b = _a.min, min = _b === void 0 ? 0 : _b, max = _a.max, _c = _a.interval, interval = _c === void 0 ? 1 : _c;
    var arr = [];
    for (var i = min; i <= max; i = i + interval) {
        arr.push(i);
    }
    return arr;
};
exports.buildOrderedNumberArray = buildOrderedNumberArray;
//# sourceMappingURL=buildOrderedNumberArray.js.map